import { DocumentType } from "../documentTypes";
import { SupportedLanguage } from "../app";
import { CategorizationAnnotation } from "../configMap/interfaces/category";
import { EntityAnnotation } from "../annotation";

export enum ExtensionType {
  PDF,
  IMAGE,
  XML,
  CSV,
  LOADING,
}

export enum EDocumentOrientation {
  LANDSCAPE,
  PORTRAIT,
  SQUARE,
}

export type MetaData = {
  language: SupportedLanguage;
  fileType: string;
  longFileType: string;
  classifiers: string;
  totalPageCount: number;
};

export type Document = {
  id: string;
  name: string;
  text: string;
  documentType: DocumentType;
  entityAnnotations?: Array<EntityAnnotation>;
  categorizationAnnotations: Array<CategorizationAnnotation>;
  metaData: MetaData;
  documentSetInputId: string;
  pageCount: number;
  /** Set by the pipeline from the file's bytes; null for documents that predate it. */
  mimeType?: string | null;
};

export interface IPdfDataAction {
  pageCount: number;
}

export interface IInViewState {
  page: number;
  inView: boolean;
}
